import { AlertCircle } from 'lucide-react'
import {
    Alert,
    AlertTitle,
    AlertDescription,
} from "@/components/ui/alert"

/**
 * Alert for displaying error messages
 */
export function ErrorAlert({ message }: { message: string }) {
    return (
        <Alert variant="destructive" className="mb-4">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>{message}</AlertDescription>
        </Alert>
    )
}